<template>
    <div id="landmarks">
      <div class="md" v-html="mdfile"></div>
      <div class="bg-slate p-1 rounded">
        <video class="embed-responsive" autoplay muted loop>
        <source src="@/assets/gel/videos/landmarks.mp4" type="video/mp4" >
        Your browser does not support HTML5 video.
        </video>
      </div>
      
    </div>
</template>

<script>
import mdfile from "@/docs/page/landmarks.md";
export default {
  name: "landmarks",
  components: {},
  beforeCreate: function() {
    this.$emit("update-title", this.$root.yamlData.page.landmarks.name);
    this.$emit("update-tagline", this.$root.yamlData.page.landmarks.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
